import { memo } from "react";
import { WebRoutes } from "consts/enpoints/web";
import {
    GettingStarted,
    BusinessInformationLabel,
    BankingAndFinanceLabel,
    MediaAndComplianceCheckLabel,
    UBOIdentityVerificationLabel,
    PaymentMethodsLabel
} from "./steps";
import { Stats, OnboardingLayout } from "../common";
import { useOnboardingApplication } from "./hooks";
import OnboardingInitialStepRedirect from "./OnboardingInitialStepRedirect";

const OnboardingGettingStarted = () => {
    const {
        isApplicationStarted,
        getApplicationModel
    } = useOnboardingApplication();

    if (isApplicationStarted()) {
        return (
            <OnboardingInitialStepRedirect
                prefix="step/"
            />
        );
    }

    return (
        <OnboardingLayout
            route={WebRoutes.Onboarding.Merchant}
            getApplicationModel={getApplicationModel}
        >
            <GettingStarted
                slots={{
                    stats: (
                        <Stats
                            route={WebRoutes.Onboarding.Merchant}
                            getApplicationModel={getApplicationModel}
                        />
                    )
                }}
            >
                {[
                    BusinessInformationLabel,
                    BankingAndFinanceLabel,
                    MediaAndComplianceCheckLabel,
                    UBOIdentityVerificationLabel,
                    PaymentMethodsLabel
                ].map((Component, index) => (
                    <Component
                        key={index}
                        sx={{
                            border: '1px solid',
                            borderColor: 'divider',
                            borderRadius: 1,
                            px: 2,
                            py: 1
                        }}
                    />
                ))}
            </GettingStarted>
        </OnboardingLayout>
    );
};

export default memo(OnboardingGettingStarted);
